// extracted by mini-css-extract-plugin
export var svgDefs = "df_jc";